export default __webpack_public_path__ + "static/media/logo-mobile.9c65ccf8.svg";